import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getDentalCodes, getDentalPayees } from '../../../../actions/adjudication.js';
import { Text, Loader, BubbleSelectBlock, Button } from '@simplybenefits/sb-ui-library';
import ProvidersTable from './ProvidersTable.js';
import CodesTable from './CodesTable.js';
import permissionLevel from '../../../../services/permissions.js';

class DentalData extends PureComponent {
    state = {
        showCodes: true,
        dentalCodes: [],
        codesOffset: 0, // The offset current search results
        codesSearch: "",
        showPayees: false,
        dentalPayees: [],
        payeesOffset: 0, // The offset current search results
        payeesSearch: "",
        yearFilter: "All",
        codeTypeFilter: "All",
        fetchingMoreData: false,
        searching: false
    };

    async componentDidMount() {
        const dentalPayees = await this.props.dispatch(getDentalPayees(this.state.payeesOffset, this.state.payeesSearch));
        const dentalCodes = await this.props.dispatch(getDentalCodes(this.state.codesOffset, this.state.codesSearch, this.state.yearFilter, this.state.codeTypeFilter));

        this.setState({
            dentalCodes,
            dentalPayees
        });
    }
    
    /**
     * Fetch more data on scroll
     */
    _fetchData = async () => {
        let data = [];
        let nextOffset = 0;

        this.setState({
            fetchingMoreData: true
        });

        if (this.state.showPayees) {
            nextOffset = this.state.payeesOffset + 1;
            data = await this.props.dispatch(getDentalPayees(nextOffset, this.state.payeesSearch));
    
            this.setState((prevState) => ({
                dentalPayees: [ ...prevState.dentalPayees, ...data ],
                payeesOffset: nextOffset,
                fetchingMoreData: false
            }));

        } else {
            nextOffset = this.state.codesOffset + 1;
            data = await this.props.dispatch(getDentalCodes(nextOffset, this.state.codesSearch, this.state.yearFilter, this.state.codeTypeFilter));
    
            this.setState((prevState) => ({
                dentalCodes: [ ...prevState.dentalCodes, ...data ],
                codesOffset: nextOffset,
                fetchingMoreData: false
            }));
        }
    };

    /**
     * Search for data with specified search term an current year dropdown
     */
    _search = async (searchTerm) => {
        this.setState({
            searching: true
        });

        let data = [];

        if (this.state.showPayees) {
            data = await this.props.dispatch(getDentalPayees(0, searchTerm));

            this.setState({
                payeesOffset: 0,
                dentalPayees: data,
                payeesSearch: searchTerm,
                searching: false
            });

        } else {
            data = await this.props.dispatch(getDentalCodes(0, searchTerm, this.state.yearFilter, this.state.codeTypeFilter));

            this.setState({
                codesOffset: 0,
                dentalCodes: data,
                codesSearch: searchTerm,
                searching: false
            });
        }
    };
        
    _setYear = async (event) => {
        await this.setState({
            yearFilter: event.target.value
        });

        this._search(this.state.codesSearch);
    };

    _setCodeType = async (event) => {
        await this.setState({
            codeTypeFilter: event.target.value
        });

        this._search(this.state.codesSearch);
    };

    /**
     * Infinite Scroll for data
     */
    _handleScroll = (event) => {
        const bottom = event.target.clientHeight + event.target.scrollTop + 1 >= event.target.scrollHeight;

        if (bottom) {
            this._fetchData();
        }
    };

    render() {
        const styles = {
            buttonWrapper: {
                display: 'flex',
                flexDirection: 'row'
            },
            uploadFeeButton: {
                height: '50px',
                alignSelf: 'center'
            },
            loading: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        };

        if (this.props.loader?.isLoading && !this.state.fetchingMoreData && !this.state.searching) {
            return <Loader/>;
        }

        return (
            <>
                <Text bold customStyle={{ fontSize: 18 }}>Filter Table Data</Text>

                <div style={ styles.buttonWrapper }>
                    <BubbleSelectBlock
                        first={{
                            title: 'Dental Codes',
                            selected: this.state.showCodes,
                            field: 'dentalCodes'
                        }}
                        second={{
                            title: 'Dental Providers',
                            selected: this.state.showPayees,
                            field: 'dentalPayees'
                        }}
                        text={null}
                        handleChange={(field) => {
                            if (field === 'dentalCodes') {
                                this.setState({
                                    showCodes: true,
                                    showPayees: false
                                });
                            } else {
                                this.setState({
                                    showPayees: true,
                                    showCodes: false
                                });
                            }
                        }}
                    />
                    
                    {
                        permissionLevel('Data Uploads', this.props.accessType).includes('write') &&
                        <Button 
                            color={'white'}
                            customStyle={styles.uploadFeeButton}
                            onClick={() => {
                                window.location.href = `/uploads`;
                            }}
                        >
                            Upload Dental Fees
                        </Button>
                    }
                </div>

                {
                    this.state.showPayees &&
                        <ProvidersTable
                            handleScroll={this._handleScroll}
                            data={this.state.dentalPayees}
                            currentSearchTerm={this.state.payeesSearch}
                            search={this._search}
                            searching={this.state.searching}
                        />
                }

                {
                    this.state.showCodes &&
                        <CodesTable
                            handleScroll={this._handleScroll}
                            data={this.state.dentalCodes}
                            currentYearFilter={this.state.yearFilter}
                            codeTypeFilter={this.state.codeTypeFilter}
                            currentSearchTerm={this.state.codesSearch}
                            search={this._search}
                            setYear={this._setYear}
                            setCodeType={this._setCodeType}
                            searching={this.state.searching}
                        />
                }

                {
                    this.state.fetchingMoreData &&
                        <div style={styles.loading}>
                            <Text>...</Text>
                        </div>
                }
            </>
        );
    }
}

/**
 * 
 * @param {*} state 
 * @returns 
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accessType: state.master.access
});

export default connect(mapStateToProps)(DentalData);